import { TaxonomyTranslationStatus } from '@taxonomy-translation/types'

const COLORS = {
  COMPLETED: '#5DD39E',
  IN_PROGRESS: '#F3B03E',
  FAILED: '#E41B0C',
}

export const getStatusColor = (status: TaxonomyTranslationStatus, percent: number): string => {
  const statusColorMap = {
    completed:
      percent >= 80 ? COLORS.COMPLETED : percent >= 30 ? COLORS.IN_PROGRESS : COLORS.FAILED,
    in_progress: COLORS.IN_PROGRESS,
    failed: COLORS.FAILED,
  }

  return statusColorMap[status] || COLORS.FAILED
}

interface Props {
  status: TaxonomyTranslationStatus
  progress: number
}

export const ColorIndicator = ({ status, progress }: Props) => (
  <div
    className="w-4 flex-shrink-0 opacity-30 group-hover:opacity-100 transition-opacity duration-200 rounded-r-md"
    style={{ backgroundColor: getStatusColor(status, progress) }}
  />
)
